import { call, put, select, takeEvery } from 'redux-saga/effects';

import { Action, RequestWithChanges, Types } from '../ducks';
import { EndpointCreator, EntityWithId, IClient, IPatchActions } from '../interfaces';
import { getEndpoint } from './endpoint';

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* patch<T>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IPatchActions<T>,
  id: string,
  changes: { [key: string]: string },
  params?: { [key: string]: string },
) {
  yield put(actions.startPatch(id));

  const endpoint: string = yield select(getEndpoint, endpointCreator, params);
  if (!endpoint) {
    return yield put(actions.failPatch(id, "couldn't create endpoint"));
  }

  try {
    const updatedEntity: EntityWithId<T> = yield call([client, 'patch'], `${endpoint}/${id}`, changes);
    return yield put(actions.completePatch(updatedEntity));
  } catch (error) {
    return yield put(actions.failPatch(id, (error as Error).message));
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function newPatchSaga<T, S>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IPatchActions<T>,
  service: S,
) {
  const isPatchRequest = (action: Action<T, S>) => action.type === Types.PATCH_REQUESTED && action.service === service;

  return function*() {
    yield takeEvery(isPatchRequest as any, (action: RequestWithChanges<S>) =>
      patch(client, endpointCreator, actions, action.payload.id, action.payload.changes, action.payload.params),
    );
  };
}
